<script setup lang="ts">
import { useAuthenticatedUserStore } from "@/services/store";
import CreateWorkOrderButton from "@/modules/root/components/CreateWorkOrderButton.vue";

const store = useAuthenticatedUserStore();

defineProps<{
  projectNumber?: string;
  workorderId?: string;
  customerNumber?: string;
  draftId?: string;
}>();
</script>

<template>
  <VMenu v-if="store.isForemanOrAbove">
    <template #activator="{ props: activatorProps }">
      <CreateWorkOrderButton v-bind="activatorProps" />
    </template>
    <VList density="compact">
      <VListSubheader>Arbetsorder</VListSubheader>

      <VListItem link :to="{ name: 'create' }">
        <VListItemTitle>Skapa ny arbetsorder</VListItemTitle>
      </VListItem>

      <VListItem v-if="projectNumber" link :to="{ name: 'create', query: { projectNumber: projectNumber } }">
        <VListItemTitle>Skapa arbetsorder i projekt {{ projectNumber }}</VListItemTitle>
      </VListItem>

      <VListItem v-if="draftId" link :to="{ name: 'create', query: { draftId: draftId } }">
        <VListItemTitle>Skapa arbetsorder från aktuellt ärende</VListItemTitle>
      </VListItem>

      <VListItem v-if="customerNumber" link :to="{ name: 'create', query: { customerNumber: customerNumber } }">
        <VListItemTitle>Skapa arbetsorder för kund: {{ customerNumber }}</VListItemTitle>
      </VListItem>

      <VListItem v-if="workorderId" link :to="{ name: 'create', query: { cloneWorkOrderId: workorderId } }">
        <VListItemTitle>Kopiera arbetsorder</VListItemTitle>
      </VListItem>

      <VListItem
        v-if="workorderId"
        link
        :to="{
          name: 'create',
          query: {
            cloneWorkOrderId: workorderId,
            projectNumber: projectNumber,
          },
        }"
      >
        <VListItemTitle>Kopiera arbetsorder med projekt {{ projectNumber }}</VListItemTitle>
      </VListItem>

      <VDivider class="my-1" />

      <VListSubheader>Ärende 2.0</VListSubheader>

      <VListItem link :to="{ name: 'create-draft-beta' }">
        <VListItemTitle>Skapa nytt ärende 2.0</VListItemTitle>
      </VListItem>
    </VList>
  </VMenu>
</template>
